import React, { Fragment } from "react";
import {
  Datagrid,
  Filter,
  TextField,
  SearchInput,
  FunctionField,
  ReferenceField,
  SelectInput,
  ListProps,
  DateInput,
} from "react-admin";
import {
  busScheduleStatusFilterList,
  formTypeFilterList,
  invoiceStatusFilterList,
  statusFilterList,
} from "./conts";
import CustomDateField from "components/CustomDateField";
import { Grid, Typography } from "@material-ui/core";
import ChangeRequestPanel from "./components/ChangeRequestPanel";
import LinkField from "./components/LinkField";
import CustomTypeField from "./components/CustomTypeField";
import TypeField from "components/TypeField";
import { SchoolIdSelected } from "utils/tools";
import CustomPagination from "components/CustomPagination";
import SanitizedGrid from "../../components/SanitizedGrid";
import { GridinRow, GridLabel } from "utils/style";
import ListShowButton from "../../components/ListShowButton";
import ListEditButton from "../../components/ListEditButton";
import ListWrapper from "../../components/ListWrapper";
import ActionsMenu from "../../components/ActionsMenu";

const ChangeRequestFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <DateInput source="WefDate" label="Wef Date" alwaysOn />
    <DateInput source="EndDate" label="End Date" alwaysOn />
    <SelectInput
      label="Status"
      source="Status"
      choices={statusFilterList}
      alwaysOn
    />
    <SelectInput
      label="Form Type"
      source="Type"
      choices={formTypeFilterList}
      alwaysOn
    />
    <SelectInput
      label="Routeplanner Role"
      source="BusScheduleStatus"
      choices={busScheduleStatusFilterList}
      alwaysOn
    />
    <SelectInput
      label="CS Role"
      source="InvoiceStatus"
      choices={invoiceStatusFilterList}
      alwaysOn
    />
  </Filter>
);

const ChangeRequestList = (props: ListProps) => {
  const breadcrumb = [{ link: "/changeRequestForms", title: "Change Request" }];

  return (
    <>
      <ListWrapper
        breadcrumb={breadcrumb}
        headerTitle="Change Requests"
        exporter={false}
        filters={<ChangeRequestFilter />}
        filter={{
          SchoolId: Number(SchoolIdSelected()),
        }}
        bulkActionButtons={false}
        title="Change request forms"
        perPage={50}
        sort={{ field: "wefDate", order: "ASC" }}
        {...props}
        pagination={<CustomPagination />}
      >
        <Datagrid expand={<ChangeRequestPanel />}>
          <TextField source="id" />
          <ReferenceField
            source="studentId"
            reference="students"
            label="Student"
            link={false}
          >
            <FunctionField
              render={(record: any) => (
                <SanitizedGrid container spacing={2}>
                  <Grid item xs={12} style={GridinRow}>
                    <Typography variant="body2" style={GridLabel}>
                      Id :
                    </Typography>
                    <TextField source="id" />
                  </Grid>

                  <Grid item xs={12} style={GridinRow}>
                    <Typography variant="body2" style={GridLabel}>
                      Name :
                    </Typography>
                    <LinkField record={record} resource="students" />
                  </Grid>

                  <Grid item xs={12} style={GridinRow}>
                    <Typography variant="body2" style={GridLabel}>
                      Created At :
                    </Typography>
                    <CustomDateField
                      source="createdAt"
                      emptyText="-"
                      isDateTime
                    />
                  </Grid>
                </SanitizedGrid>
              )}
            />
          </ReferenceField>
          <CustomDateField source="wefDate" emptyText="-" />
          <CustomDateField source="endDate" emptyText="-" />
          <TypeField source="type" type="changeRequest_FormType" />
          <CustomTypeField
            source="busScheduleStatus"
            label="Routeplanner Role"
            type="changeRequest_busSchedule"
          />
          <CustomTypeField
            source="invoiceStatus"
            label="CS Role"
            type="changeRequest_invoice"
          />
          <CustomTypeField
            source="status"
            label="Status"
            type="changeRequest_status"
          />
          <FunctionField
            label="Updated By"
            render={(record: any) => {
              if (record.logs && record.logs.length > 0) {
                // get latest log
                const latestLogIndex = record.logs.length - 1;

                return (
                  <Fragment>
                    <TextField
                      source={`logs[${latestLogIndex}].user.admin.fullName`}
                      emptyText="-"
                    />
                    {" - "}
                    <CustomDateField
                      source={`logs[${latestLogIndex}].loggedAt`}
                      isDateTime
                    />
                  </Fragment>
                );
              }

              return <>-</>;
            }}
          />
          <FunctionField
            label="Created By"
            render={(record: any) => {
              if (
                record.logs &&
                record.logs.length > 0 &&
                record.logs[0].status.toLowerCase() === "created"
              ) {
                // get first log
                return (
                  <Fragment>
                    <TextField
                      source={`logs[0].user.admin.fullName`}
                      emptyText="-"
                    />
                    {" - "}
                    <CustomDateField source={`logs[0].loggedAt`} isDateTime />
                  </Fragment>
                );
              }

              return <CustomDateField source={`createdAt`} isDateTime />;
            }}
          />
          <FunctionField
            label="Actions"
            render={(record: any) => (
              <ActionsMenu
                render={[
                  <ListShowButton record={record} />,
                  <ListEditButton record={record} />,
                ]}
              />
            )}
          />
        </Datagrid>
      </ListWrapper>
    </>
  );
};

export default ChangeRequestList;
